import { render, staticRenderFns } from "./TheDownloadBtn.vue?vue&type=template&id=674f090e&scoped=true&"
import script from "./TheDownloadBtn.vue?vue&type=script&lang=js&"
export * from "./TheDownloadBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674f090e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
